import React from "react";
import styles from "../scss/ReviewBox.module.scss";
import StarIcon from "../../../../Shared/Icons/StarIcon";

const ReviewBox = ({ name, text, color }) => {
  return (
    <div className={styles.reviewBox}>
      <div className={styles.reviewBoxHeader}>
        <div className={styles.reviewImage} style={{ background: color }}>
          {name[0]}
        </div>
        <span className={styles.reviewName}>{name}</span>
        <div className={styles.reviewStarsContainer}>
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <StarIcon />
        </div>
      </div>
      <div className={styles.reviewBoxContent}>
        <p className={styles.reviewBoxText}>{text}</p>
      </div>
      <div className={styles.reviewBoxFooter}>
        <img src="/images/google.png" alt="" className={styles.googleReviewImg} />
        <span>Google Review</span>
      </div>
    </div>
  );
};

export default ReviewBox;
